/* global io */
import React from 'react';

import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import LiveTv from '@material-ui/icons/LiveTv';
import Brush from '@material-ui/icons/Brush';
import Archive from '@material-ui/icons/Archive';
import Code from '@material-ui/icons/Code';
import VideoLibrary from '@material-ui/icons/VideoLibrary';
import Confirm from '../Utils/Confirm';
import CircularProgress from '@material-ui/core/CircularProgress';
import Done from '@material-ui/icons/Done';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
//https://material.io/tools/color 

 import Embed from './Embed';

class Sepa extends React.Component {
  render() {
    return (
      <span>&nbsp;&nbsp;&nbsp;</span>
    )
  }
}

export default class Action extends React.Component {

  state = {
    live: false,
    isBroadcasting: false,
    isRecording: false,
    isExporting: false,
    showPopinEmbed: false,
    isConverting: false
  }

  style = {
    textAlign: 'center'
  }

  showCustom(type) {
    window.sdk.emit('showCustom', {
      type: type
    })
  }

  handleAgreeVod = () => {
    //alert('ok2');
    window.sdk.convertToVod();
    this.setState({
      isConverting: true
    })
  }
  
  handleAgreeLive = () => {
    //alert('ok2');
    window.sdk.convertToLive();
  }

  convertToVod = () => {
    this.refs['confirmConvertVod'].show()
  }
  

  convertToLive = () => {
    this.refs['confirmConvertLive'].show()
  }

  exportZip = async () => {
        let elSize;
        this._socket = io(this.apiUrl);
        this._socket.on('connect', async (socket) => {
          console.log('socket connected');
          window.location = '/export/'+window.programId + '?socketId=' + this._socket.id;     
          await this.setState({zipStep: 'progress'});
          elSize = document.getElementById('size-zip-processing');
            
        });    


        this._socket.on('ZipSize', async (size) => {
          elSize.innerHTML = this.bytesToSize(size);
        }); 
        
        this._socket.on('zipEnd', async (data) => {
          this.setState({zipStep: 'finish'});
          //this._socket.disconnect();
        });
  }
  
  bytesToSize(aSize) {
    aSize = Math.abs(parseInt(aSize, 10));
  	var def = [[1, 'octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']];
  	for(var i=0; i<def.length; i++){
  		if(aSize<def[i][0]) return (aSize/def[i-1][0]).toFixed(2)+' '+def[i-1][1];
  	}
  }  
  
  toggleLive = async () => {
    if (!this.state.isBroadcasting) {
      this.refs['startLiveConfirm'].show()
      //await window.sdk.live.startLive();
    }
    else {
      this.refs['stopLiveConfirm'].show()
      //await window.sdk.live.stopLive();
    }
    //await this.reloadInfo();
    //window.sdk.emit('broadcasting', this.state.isBroadcasting);
  }
  
  handleAgreeStart = () => {
    window.sdk.live.startLive();
  }
  
  handleAgreeStop = () => {
    window.sdk.live.stopLive();
  }

  toggleRecord = async () => {
    if (!this.state.isRecording) {
      this.refs['startRecordConfirm'].show()
      //await window.sdk.live.startRecord();
    }
    else {
      this.refs['stopRecordConfirm'].show()
      //await window.sdk.live.stopRecord();
    }
    //await this.reloadInfo();
  }
  
  handleAgreeRecordStart = () => {
    window.sdk.live.startRecord();
  }
  
  handleAgreeRecordStop = () => {
    window.sdk.live.stopRecord();
  }
  
  /*async reloadInfo() {
    let info = await window.sdk.live.reLoadInfo();
    await this.setState({
      isBroadcasting: info.program.live_state,
      isRecording: info.program.record_state,
    })
  }*/

  componentDidMount() {
    window.sdk.on('monitorStream', async (isLive, isBroadcasting, isRecording) => {
      //let info = await window.sdk.live.reLoadInfo();
      console.log(isLive, isBroadcasting, isRecording)
      await this.setState({
        live: isLive,
        isBroadcasting: isBroadcasting,
        isRecording: isRecording
      })
      /*await this.reloadInfo();
      window.sdk.emit('broadcasting', this.state.isBroadcasting);*/
    });
  }
  
  
  toggleEmbed = () => {
    this.setState({showPopinEmbed:!this.state.showPopinEmbed})
  }
  
  popupEmbed =() => {
    return (
     
      <Dialog
          onClose={this.toggleEmbed}
          aria-labelledby="customized-dialog-title"
          open={this.state.showPopinEmbed}
        >
          <DialogTitle>{this.state.dialogTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Embed />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.toggleEmbed} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
    );    
  }

  render() {
    return (
      <Grid className={ 'action' } container direction="row">
        
        <Confirm ref="confirmConvertVod" description="En convertissant ce live en vod, il ne sera plus possible d'utiliser le live manager" handleAgree={ this.handleAgreeVod } />
        
        <Confirm ref="confirmConvertLive" description="En convertissant cette vod en live, tous les chapitres seront supprimés" handleAgree={ this.handleAgreeLive } />
        
        <Confirm ref="startLiveConfirm" description="Vous êtes sur de vouloir DEMARRER le live ?" handleAgree={ this.handleAgreeStart } />
        
        <Confirm ref="stopLiveConfirm" description="Vous êtes sur de vouloir STOPPER le live ?" handleAgree={ this.handleAgreeStop } />
        
        <Confirm ref="startRecordConfirm" description="Vous êtes sur de vouloir DEMARRER l'enregistrement ?" handleAgree={ this.handleAgreeRecordStart } />
        
        <Confirm ref="stopRecordConfirm" description="Vous êtes sur de vouloir STOPPER l'enregistrement ?" handleAgree={ this.handleAgreeRecordStop } />
        
        
        <Sepa />
        
        { !window.isVod &&
          <Fab color={ !this.state.isBroadcasting ? 'primary' : 'inherit' } variant="extended" disabled={ !this.state.live } onClick={ this.toggleLive } >
            <LiveTv  />
            { !this.state.isBroadcasting ? 'Démarrer le live':'Stopper le live' }
          </Fab>
        }
        
        <Sepa />
        
        { !window.isVod &&
          <Fab color={ !this.state.isRecording ? 'secondary' : 'inherit' }  variant="extended" disabled={ !this.state.isBroadcasting || !this.state.live } onClick={ this.toggleRecord } >
            <FiberManualRecord  />
            { !this.state.isRecording ? 'Démarrer l\'enregistrement':'Stopper l\'enregistrement' }
          </Fab>
        }
        <Sepa />
        
        <Fab onClick={ () => { this.showCustom('channel') } } variant="extended" >
          <Brush  />
          Channel
        </Fab>
        
        <Sepa />
        
        <Fab onClick={ () => { this.showCustom('program') } } variant="extended" >
          <Brush  />
          Programme
        </Fab>
        
        <Sepa />
        

        { (!window.isVod && !this.state.isConverting) &&
          <Fab  disabled={ this.state.live } onClick={ this.convertToVod } variant="extended" >
            <VideoLibrary  />
            Convertir en VOD
          </Fab>
        }
        
        { this.state.isConverting &&
          <span>Conversion en cours</span>
        }
        
        { window.isVod &&
          <Fab  disabled={ this.state.live } onClick={ this.convertToLive } variant="extended" >
            <VideoLibrary  />
            Revenir en mode live
          </Fab>
        }

        <Sepa />
        
        { window.isVod &&
          <Fab onClick={ this.exportZip } variant="extended" >
            <Archive  />
            Export ZIP
          </Fab>
        }
        
        <Sepa />
         
        { this.state.zipStep == 'progress' &&
        <div className="data-zip">
          <div className="data-zip-icon"><CircularProgress /></div>
          <div className="data-zip-info">Génération de l'archive<div id="size-zip-processing">Préparation...</div>
          </div>
        </div>
        }
        { this.state.zipStep == 'finish' &&
        <div className="data-zip data-zip-done">
          <div className="data-zip-icon"><Done /></div>
          <div className="data-zip-info">Export terminé ! </div>
        </div>
        }
         <Sepa />
        <Fab onClick={ this.toggleEmbed } variant="extended" >
          <Code  />
          Embed
        </Fab>
        
         { this.popupEmbed() }
        
      </Grid>
    )
  }

}



// WEBPACK FOOTER //
// ./src/Manager/Action.js